module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ChFront1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter01"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter01#fm1-sec1"
    }
  }, [_vm._v("MAKE-AHEAD PLANNER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LARGE PLATTERS AND SMALL BITES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curry Cashews")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spiked Olives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rosemary Almonds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dilled Green Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warm Green Olives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gorgonzola Bites")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two-Olive Tapenade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1-sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Eggplant Dip with Spiced Pita Crisps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1-sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Tomato Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1-sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Texas Caviar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1-sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salumi with Italian Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1-sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oysters with Preserved–Meyer Lemon Mignonette")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1-sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Vegetable Platter with Arugula Green Goddess Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1-sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Goat Cheese with Cumin and Mint")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1-sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seasonal Cheese and Fruit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WARM FINGER FOODS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baby Lamb Chops with Mint-Cilantro Relish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cornmeal Blini with Smoked Salmon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tandoori Chicken Spears")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Merguez Meatballs with Yogurt Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chorizo and Potatoes with Romesco")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salt-Roasted Prawns with Lemon Pesto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wild Mushroom Croustades")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2-sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato-Gruyère Tart Squares")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2-sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arancini")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2-sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheddar-Chive Gougères")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2-sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warm Dates with Sea Salt and Lime")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2-sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Apricots with Serrano Ham")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2-sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sausage-Stuffed Cremini")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2-sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig and Gorgonzola Crostini with Caramelized Onions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2-sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mystery Tidbits and Hasty Hots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COOL FINGER FOODS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baby Artichokes with Lemon Mayonnaise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stuffed Eggs Caviar-Style")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parmesan-Pepper Twists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cured Salmon with Pimentón")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Filet Mignon with Horseradish Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuna Poke in Wonton Cups")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foie Gras Pâté on Brioche with Fig Jam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3-sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endive with Crab Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3-sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crostoni with Fava Beans and Ricotta Salata")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3-sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato–Pine Nut Bruschetta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3-sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herbed Goat Cheese with Nasturtiums")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3-sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cherry Tomatoes Stuffed with Avocado and Bacon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3-sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crostini with Roasted Eggplant, Red Pepper, and Mozzarella")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOMETHING SWEET")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate-Hazelnut Truffles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sugar and Spice Walnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon-Ginger Madeleines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mocha Shortbread Buttons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE OF EQUIVALENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COPYRIGHT")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0